<app-header titulo="SALIDAS"></app-header>
<div class="row mt-5">
    <div class="col-sm-4"></div>
    <div *ngIf="this.proveedores.length > 0" class="col-sm-4 text-center bg-transparente p-5">

        <div class="row">
            <div class="col">

                <div class="row">
                    <div class="col text-left">
                        <h3><strong>Motivo Salida</strong></h3>
                    </div>
                </div>
                <div class="row">
                    <div class="col text-center bg-white">
                        <h1><strong>{{ this.proveedores[this.indice].nombre | uppercase }}</strong></h1>
                    </div>
                </div>

            </div>
        </div>

        <div class="row">
            <div class="col">

                <div class="row">
                    <div class="col text-left">
                        <h3><strong>Monto Salida</strong></h3>
                    </div>
                </div>
                <div class="row">
                    <div class="col text-center bg-white">
                        <h1><strong>{{ this.monto | number }}</strong></h1>
                    </div>
                </div>

            </div>
        </div>

        <div class="row mt-5">
            <div class="col-6">

                <button type="button" class="btn btn-danger btn-lg btn-block">(Esc) Cancelar</button>

            </div>
            <div class="col-6">

                <button type="button" name="" id="" class="btn btn-success btn-lg btn-block">(Enter) Aceptar</button>

            </div>
        </div>



    </div>
    <div class="col-sm-4"></div>
</div>
